'use strict';

const STEP = {
  TYPE : {
    TASK: 1,
    MAIL: 2,
    LINKEDIN_VISIT_PROFILE: 3,
    LINKEDIN_SEND_INVITATION: 4,
    LINKEDIN_SEND_CHAT_MESSAGE: 5,
  },
};

const STEP_TASK_TYPE_ID = {
  PHONE: 1,
  LINKEDIN: 2,
  MAIL: 3,
  OTHER: 4,
};

const STEP_INTERVAL_EVENT_LIST = [
  {
    name: 'La tâche est crée',
    value: 1,
    attribute: 'task_created',
  },
  {
    name: 'La tâche est finalisée',
    value: 2,
    attribute: 'task_done',
  },
];

const STEP_TYPE_NAMES = {
  [STEP.TYPE.TASK]: 'task',
  [STEP.TYPE.MAIL]: 'email',
  [STEP.TYPE.LINKEDIN_VISIT_PROFILE]: 'linkedin-visit-profile',
  [STEP.TYPE.LINKEDIN_SEND_INVITATION]: 'linkedin-send-invitation',
  [STEP.TYPE.LINKEDIN_SEND_CHAT_MESSAGE]: 'linkedin-send-chat-message',
};

const STEP_CARD_TITLES = {
  [STEP.TYPE.LINKEDIN_VISIT_PROFILE]: 'Visiter le profil',
  [STEP.TYPE.LINKEDIN_SEND_INVITATION]: 'Envoyer une invitation',
  [STEP.TYPE.LINKEDIN_SEND_CHAT_MESSAGE]: 'Message chat',
  [STEP.TYPE.MAIL]: 'Mail automatisé',
  [STEP.TYPE.TASK]: 'Tâches',
};

const STEP_ICONS = {
  [STEP.TYPE.LINKEDIN_VISIT_PROFILE]: 'prospects',
  [STEP.TYPE.LINKEDIN_SEND_INVITATION]: 'send',
  [STEP.TYPE.LINKEDIN_SEND_CHAT_MESSAGE]: 'mail-send',
  [STEP.TYPE.MAIL]: 'mail3',
  [STEP.TYPE.TASK]: 'task',
};

const STEP_MAX_COUNT = 7;

const EMAIL_EVENT = {
  SENT: 'sent',
  OPENED: 'opened',
  CLICKED: 'clicked',
  REPLIED: 'replied',
  REPLIED_POSITIVE: 'replied_positive',
  REPLIED_NEGATIVE: 'replied_negative',
  AUTOREPLIED: 'autoreplied',
  BOUNCED: 'bounced',
  NOT_SENT: 'not_sent',
};

const LINKEDIN_EVENT = {
  VISITED_PROFILE: 'visited_profile',
  INVITATION_SENT: 'invitation_sent',
  INVITATION_ACCEPTED: 'invitation_accepted',
  INVITATION_ALREADY_CONNECTED: 'invitation_already_connected',
  INVITATION_EXPIRED: 'invitation_expired',
  INVITATION_NOT_ACCEPTED: 'invitation_not_accepted',
  INVITATION_REFUSED: 'invitation_refused',
  MESSAGE_SENT: 'message_sent',
  MESSAGE_REPLIED: 'message_replied',
  MESSAGE_REPLIED_POSITIVE: 'message_replied_positive',
  MESSAGE_REPLIED_NEGATIVE: 'message_replied_negative',
};

const STEP_TARGET_EVENT_LIST = {
  EVENT_ID_MAIL_REPLIED: 1,
  EVENT_ID_NO_EMAIL: 2,
  EVENT_ID_OPTOUT: 3,
  EVENT_ID_INACTIVE: 4,
  EVENT_ID_SKIPPED: 5,
  EVENT_ID_NO_LINKEDIN: 6,
  EVENT_ID_IGNORE_CONTACT: 7,
  EVENT_ID_LINKEDIN_ERROR: 8,
};

const TASK_STATUS = {
  TODO: 'todo',
  LATE: 'late',
  DONE: 'done',
};

const STEP_LINKEDIN_STATUS_ID = {
  INVITATION_SENT: 1,
  INVITATION_EXISTS: 2,
  INVITATION_EXPIRED: 3,
  MESSAGE_RESPONDED: 4,
  INVITATION_REFUSED: 5,
  MESSAGED_READ: 6,
  INVITATION_ACCEPTED: 101,
  INVITATION_ALREADY_CONNECTED: 102,
};

const STEP_STATUS = {
  DRAFT: 'draft',
  ON_GOING: 'on_going',
  DONE: 'done',
  PAUSED: 'paused',
};

const STEP_LINKEDIN_MESSAGE_RESPONDED_STATUS_ID = {
  INTERESTED: 1,
  NOT_INTERESTED: 2,
};

const STEP_TARGET_STATUS = {
  MAIL_REPLIED: 'step_target_status_mail_replied',
  NO_EMAIL: 'step_target_status_no_email',
  OPTOUT: 'step_target_status_optout',
  INACTIVE: 'step_target_status_inactive',
  SKIPPED: 'step_target_status_skipped',
  NO_LINKEDIN: 'step_target_status_no_linkedin',
  IGNORE_CONTACT: 'step_target_status_ignore_contact',
  LINKEDIN_ERROR: 'step_target_status_linkedin_error',
  NOT_ELIGIBLE_TASK: 'step_target_status_not_eligible_task',
  NOT_ELIGIBLE_MAIL: 'step_target_status_not_eligible_mail',
  NOT_ELIGIBLE_LINKEDIN: 'step_target_status_not_eligible_linkedin',
  EMAIL_BOUNCED: 'step_target_status_email_bounced',
  EMAIL_AUTOREPLIED: 'step_target_status_email_autoreplied',
  EMAIL_REPLIED: 'step_target_status_email_replied',
  EMAIL_REPLIED_INTERESTED: 'step_target_status_email_replied_interested',
  EMAIL_REPLIED_NOT_INTERESTED: 'step_target_status_email_replied_not_interested',
  EMAIL_SENT: 'step_target_status_email_sent',
  EMAIL_DRAFT: 'step_target_status_email_draft',
  TASK_DONE: 'step_target_status_task_done',
  LINKEDIN_INVITATION_SENT: 'step_target_status_linkedin_invitation_sent',
  LINKEDIN_MESSAGE_SENT: 'step_target_status_linkedin_message_sent',
  LINKEDIN_PROFILE_VISITED: 'step_target_status_linkedin_profile_visited',
  LINKEDIN_STATUS_INVITATION_SENT: 'step_target_status_linkedin_status_invitation_sent',
  LINKEDIN_STATUS_INVITATION_EXISTS: 'step_target_status_linkedin_status_invitation_exists',
  LINKEDIN_STATUS_INVITATION_EXPIRED: 'step_target_status_linkedin_status_invitation_expired',
  LINKEDIN_STATUS_INVITATION_REFUSED: 'step_target_status_linkedin_status_invitation_refused',
  LINKEDIN_STATUS_MESSAGED_READ: 'step_target_status_linkedin_status_messaged_read',
  LINKEDIN_STATUS_INVITATION_ACCEPTED: 'step_target_status_linkedin_status_invitation_accepted',
  LINKEDIN_STATUS_INVITATION_ALREADY_CONNECTED: 'step_target_status_linkedin_status_invitation_already_connected',
  LINKEDIN_STATUS_MESSAGE_RESPONDED: 'step_target_status_linkedin_status_message_responded',
  LINKEDIN_MESSAGE_INTERESTED: 'step_target_status_linkedin_message_interested',
  LINKEDIN_MESSAGE_NOT_INTERESTED: 'step_target_status_linkedin_message_not_interested',
};

const STEP_STATISTICS_TYPE = {
  INTERESTED: 'interested',
};

const STEP_TARGET_DONE_EVENT = {
  INACTIVE: 'INACTIVE',
};

const STEP_CONSTANTS = {
  EMAIL_EVENT,
  LINKEDIN_EVENT,
  STEP,
  STEP_CARD_TITLES,
  STEP_ICONS,
  STEP_INTERVAL_EVENT_LIST,
  STEP_LINKEDIN_STATUS_ID,
  STEP_LINKEDIN_MESSAGE_RESPONDED_STATUS_ID,
  STEP_MAX_COUNT,
  STEP_STATISTICS_TYPE,
  STEP_STATUS,
  STEP_TARGET_EVENT_LIST,
  STEP_TARGET_DONE_EVENT,
  STEP_TARGET_STATUS,
  STEP_TASK_TYPE_ID,
  STEP_TYPE_NAMES,
  TASK_STATUS,
};

export {
  STEP_CONSTANTS,
};
